export const optumThemeOverride = {
  theme: {
    colors: {
      infoFooterBackground: '#f4f6fa',
      uhcPrimary1: '#002677',
      pageBodyBgColor: '$white',
      neutralGray: '$gray7',
      neutralGray2: '#F2F2F2',
      neutralGray4: '$gray4',
      neutralGray5: '#6E7072',
      cardBorder: '$gray3',
      neutralGray7: '$gray8',
      lightGray: '#D0D0D0',
      lightBlue: '#D9F6FA',
      bgHeaderColor: '$lightBlue',
      bgSubHeaderColor: '$lightBlue',
      starBorder: '#D2800F',
      snackCardAvatarBackgroundColor: '#EEF8FB',
      bgProviderDetailsColor: '#FBF9F4',
      icColor: '$interactive1',
      tcolor: '$uhcPrimary1',
      tabsContainerBackgroundColor: '#DAF6FA',
      tabButtonBackgroundColor: '#FFFFFF',
      tabSelectionTextColor: '$uhcPrimary1',
      tabNotSelectedTextColor: '#424242',
      descriptionBlack: '#19191A',
      whereToGetHelpCardBg1: '$lightBlue',
      whereToGetHelpCardBg2: '$lightBlue',
      whereToGetHelpCardBg3: '$lightBlue',
      milesTextColor: '$interactive1',
      headerCardWrapperBorderColor: '$lightBlue',
      virtualVisitIconColor: '$interactive1',
      searchBorderColor: '$gray5',
      recentVisitCardSliderBg: '$lightBlue',
      memberInitialsBgColor: '#FFFFFF',
      memberInitialsTextColor: '#424242',
      mapViewContainerBgColor: '$white',
      providerDetailsDrawerHeaderBgColor: '$tint1',
      providerDetailsDrawerHeaderLoadingBgColor: '$tint2',
      providerDetailsDrawerHeaderTextColor: '#4B4D4F',
      providerDetailsDrawerHeaderHighlightColor: '$primary1',
      providerDetailsDrawerHeaderInNetworkStatusIconColor: '#007000',
      providerDetailsDrawerHeaderInNetworkStatusLabelColor: '#4B4D4F',
      providerDetailsDrawerLocationsDropdownOptionColor: '#323334',
      searchIconColor: '$interactive1',
      errorTextColor: '#D14600',
      notificationColor: '$primary1',
      notificationInteractiveColor: '$interactive1',
      refreshIconColor: '$interactive2',
      subTextcolor: '#002677',
      orText: '#002677',
    },
    fontSizes: {
      dateInfoText: '16px',
      providerDetailsDrawerBHFooterTimeStampText: '$sm',
      providerDetailsDrawerBHFooterDateText: '12px',
    },
    lineHeights: {},
    space: {
      wrapperPadding: '24px 0',
      headerWrapperPadding: '24px 0 0 0',
      tabButtonsPadding: '32px 0 0 0',
      recentSearchBottomGap: 0,
      recentActivityTopPadding: '0px',
      popoverContainerTop: '0px',
    },
    fontWeights: {
      normalFW: 'normal',
      boldFW: 'bold',
      memeberInitialsFW: '700',
      providerDetailsDrawerHeaderInNetworkFW: '$normal',
      providerDetailsDrawerBHFooterDateFW: '$normal',
    },
    borderWidths: {
      recentActivityBorder: '0px',
    },
    sizes: {
      iconBrandSize: '64px',
      dataCardForMapIconSize: '42px',
      dataCardIconSize: 49,
      snackCardIconSize: 72,
      snackCardIconMobileSize: 60,
      detailsIconSize: 84,
      compareAndShareIconSize: 64,
      recentVisitSnackcardIconSize: 56,
      detailsWidgetHeaderIconSize: 84,
      choosePCPLocationIconSize: 42,
      confirmPCPLocationIconSize: 42,
      choosePCPSuccessIconSize: 45,
    },
    fonts: {
      primary: 'var(--font-optumsans)',
      heading: 'var(--font-optumsans)',
    },
    overflow:{
      popoverContentOverflow:'visible'
    },
    maxHeight:{
      popoverContentHeight:'unset'
    }
  },
};
